import { TeamMemberInviteFormFields } from '@anm/components/team/TeamMemberInviteForm';
import TeamMemberInviteForm from '@anm/components/team/TeamMemberInviteForm/index';
import TeamModal from '@anm/components/team/TeamModal';
import useDependPendingCallback from '@anm/hooks/useDependPendingCallback';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { teamActions, teamSelectors } from '../../../store/modules/team';
import { userSelectors } from '../../../store/modules/user';

export type InviteMemberProps = { onModalClose: () => void };

const InviteMember: FC<InviteMemberProps> = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const userPermissions = useSelector(userSelectors.selectTeamPermissions);

  const isPending = useSelector(teamSelectors.selectMemberInvitePending);

  const handleSubmit = ({ email, displayName, role }: TeamMemberInviteFormFields) => {
    dispatch(teamActions.inviteMember({ email, role, name: displayName }));
  };

  useDependPendingCallback(isPending, onModalClose);

  return (
    <TeamModal title="Invite new team member" onModalClose={onModalClose}>
      <TeamMemberInviteForm
        permissions={userPermissions}
        isPending={isPending}
        initialValues={{ displayName: '', email: '', role: 'VIEWER' }}
        onSubmit={handleSubmit}
      />
    </TeamModal>
  );
};

export default InviteMember;
